import { Button, Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import HtmlParser from 'html-react-parser';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { DistributionType, SurveyStatusType } from '../../../models';

export const DuplicateEmailsWarningContainer = styled.div`
	margin-bottom: 15px;
`;
DuplicateEmailsWarningContainer.displayName = 'DuplicateEmailsWarningContainer';

export const ShowDuplicatesMessageContainer = styled.div`
	margin-top: 20px;
`;
ShowDuplicatesMessageContainer.displayName = 'ShowDuplicatesMessageContainer';

export interface IDuplicateEmailWarningProps {
	distributionType: DistributionType;
	surveyStatus: SurveyStatusType;
	duplicateContactsCount: number;
	onShowDuplicatesClick?: () => void;
}

export class DuplicateEmailsWarning extends React.Component<IDuplicateEmailWarningProps> {
	public render() {
		const { distributionType, surveyStatus, duplicateContactsCount, onShowDuplicatesClick } = this.props;
		return (
			(surveyStatus === SurveyStatusType.Scheduled || surveyStatus === SurveyStatusType.SurveyInProgress) &&
			duplicateContactsCount > 0 && (
				<DuplicateEmailsWarningContainer>
					<Pullout type={PulloutType.Warning}>
						{HtmlParser(
							ContentConstants.WARNING_STRONG +
								' ' +
								ContentConstants.SURVEY_PARTICIPANTS_DUPLICATE_EMAILS_WARNING_PREFIX +
								' ' +
								(distributionType === DistributionType.Unique
									? ContentConstants.SURVEY_PARTICIPANTS_DUPLICATE_EMAILS_WARNING_UNIQUE
									: ContentConstants.SURVEY_PARTICIPANTS_DUPLICATE_EMAILS_WARNING_SINGLELINK),
						)}
						{onShowDuplicatesClick && (
							<ShowDuplicatesMessageContainer>
								<Button id='show-duplicate-emails' onClick={onShowDuplicatesClick} size='md'>
									View Duplicates
								</Button>
							</ShowDuplicatesMessageContainer>
						)}
					</Pullout>
				</DuplicateEmailsWarningContainer>
			)
		);
	}
}
